import { Component, OnInit } from '@angular/core';
import { OrderTermsJeevesComponent } from 'gung-standard-jeeves';

@Component({
  selector: 'cult-cult-order-terms-jeeves',
  templateUrl: './cult-order-terms-jeeves.component.html',
  styleUrls: ['./cult-order-terms-jeeves.component.scss']
})
export class CultOrderTermsJeevesComponent extends OrderTermsJeevesComponent {

  dateSelected(event) {
    const date = event.date;
    const dString: string = this.datePipe.transform(date, 'yyyy-MM-dd');
    this.checkout.extra.oh.ordberlevdat = dString;
    this.checkout.rows = this.checkout.rows.map(row => {
      row.extra.procargs = {
        ...row.extra.procargs,
        ordberlevdat: dString
      }
      return row;
    });
  }

}
